module.exports = __webpack_public_path__ + "static/media/panel.search.9ba0b2fb.png";